export type PortfolioAllocation = Record<string, number>; // asset class -> allocation %

export type AssetReturns = Record<string, number>;

export interface CalculatedPortfolioReturns {
    equities: number;
    fixedIncome: number;
}

export interface CalculatedPortfolioAllocation {
    equities: number;
    fixedIncome: number;
}

export enum AssetClass {
    // Equity Classes
    LARGE_GROWTH = 'Large Growth',
    LARGE_VALUE = 'Large Value',
    MID_CAP = 'Mid Cap',
    SMALL_CAP = 'Small Cap',
    INTERNATIONAL_EQUITIES = 'International Equities',
    EMERGING_MARKETS = 'Emerging Markets',
    REAL_ESTATE = 'Real Estate',

    // Fixed Income Classes
    GOVERNMENT = 'Government',
    MUNICIPAL = 'Municipal',
    CORPORATE = 'Corporate',
    HIGH_YIELD = 'High Yield',
    INTERNATIONAL_BONDS = 'International Bonds',
    CASH = 'Cash',
}

export const EQUITY_CLASSES = [
    AssetClass.LARGE_GROWTH,
    AssetClass.LARGE_VALUE,
    AssetClass.MID_CAP,
    AssetClass.SMALL_CAP,
    AssetClass.INTERNATIONAL_EQUITIES,
    AssetClass.EMERGING_MARKETS,
    AssetClass.REAL_ESTATE,
];

export const FIXED_INCOME_CLASSES = [
    AssetClass.GOVERNMENT,
    AssetClass.MUNICIPAL,
    AssetClass.CORPORATE,
    AssetClass.HIGH_YIELD,
    AssetClass.INTERNATIONAL_BONDS,
    AssetClass.CASH,
];
